import { useAnswerBlocks, useAssessmentFragment } from "@/graphql/hooks";
import { useWorkContext } from "@/stores/work-context";

import { AnswerPreview } from "./answer-preview";

/**
 * Connect AnswerPreview to graphql and redux data.
 */
export function AnswerPreviewWithData() {
  const { workId } = useWorkContext();
  const answerBlocks = useAnswerBlocks(workId);
  const { data } = useAssessmentFragment();

  return (
    <AnswerPreview
      answerBlocks={answerBlocks}
      assessmentName={data?.name ?? ""}
      showAlertOnUnAnswered
    />
  );
}
